export const updateProjects = ({ BeURL, id, projects, showAlert, handleTopClear, setProjects }) => {
    fetch(`${BeURL}/candidate-projects/${id}`, {
        method: "PUT",
        credentials: "include",
        headers: {
            "Content-Type": "application/json",
        },
        body: JSON.stringify({ projects}),
    })
        .then((res) => res.json())
        .then((data) => {
            if (data.success) {
                showAlert(data.message);
                setProjects(data.projects)
                handleTopClear()
            } else {
                showAlert(data.message);
            }
        })
        .catch((err) => {
            console.log("Error in updating projects", err);
        });
}
